export default __webpack_public_path__ + "static/media/down.b9f84d9c.svg";